<template>
  <div
    id="row"
    class="d-flex flex-column align-items-left justify-content-center"
    v-bind:class="{ breakfast: isBreakfast }"
  >
    <div class="d-flex flex-rows justify-content-between align-items-center">
      <div class="white col1">
        <div class="category">{{category.lg1}}</div>
        <div class="type grey">{{type.lg1}}</div>
      </div>
      <div class="price1 white col2">{{price}}</div>
      <div class="price2 white col3" v-if="price2">{{price2}}</div>
      <div class="price3 white col4" v-if="price3">{{price3}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MercureRatesHorizontalV1RatesRow",
  props: {
    ratesLg1: Array,
    isBreakfast: Boolean,
  },
  computed: {
    category() {
      return {
        lg1: this.ratesLg1[0].label_value,
      };
    },
    type() {
      return { lg1: this.ratesLg1[0].sub_label };
    },
    price() {
      return this.ratesLg1[0].mrr_value;
    },
    price2() {
      return this.ratesLg1[1] ? this.ratesLg1[1].mrr_value : "";
    },
    price3() {
      return this.ratesLg1[2] ? this.ratesLg1[2].mrr_value : "";
    },
  },
};
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_tribe.scss";

#row {
  width: 100%;
  //@include heightPercent(120);
  flex-grow: 1;
  border-bottom: 1px solid $grey;

  .category {
    //max-height: 2rem;
    overflow: hidden;
  }

  .type {
    //max-height: 3rem;
    overflow: hidden;
    margin-top: -0.5rem;
  }

  &.breakfast {
    .category,
    .type {
      display: inline-block;
    }

    .type {
      line-height: 2.8rem;
    }
  }

  .price1,
  .price2 {
    margin-bottom: 25 * 100vh / $srcHeight;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/rates/rowRates.vue